import CreateProjectTab from 'components/project/clinic/CreateProjectTab';
import ProjectIndicationMaterial from 'components/project/clinic/ProjectIndicationMaterial';
import ProjectIndicationNone from 'components/project/clinic/ProjectIndicationNone';
import ProjectIndicationShade from 'components/project/clinic/ProjectIndicationShade';
import ProjectIndicationType from 'components/project/clinic/ProjectIndicationType';
import { useCreateProjectIndication } from 'lib/hooks/project/useCreateProjectIndication';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

function CreateProjectIndicationContainer() {
  // SECTION: state

  // SECTION: variable

  // SECTION: declare hooks
  const {
    indicationMaterialList,
    materialIdx,
    isSelectedTooth,
    indicationTab,
    tabList,
    isTypeMore,
    indicationPartList,
    indicationIdx,
    indicationShadeList,
    materialShade,
    onMoreChange,
    onIndicationChange,
    onMaterialChange,
    onTabChange,
    onShadeChange,
  } = useCreateProjectIndication();
  const { t } = useTranslation();

  // SECTION: declare function

  return (
    <StyledCreateProjectIndication $isSelectedTooth={isSelectedTooth}>
      <div className="createProjectIndicationContainer__tab_container">
        <CreateProjectTab
          tabTitle={t('PROJECT_INDICATORS')}
          tabIndex={indicationTab}
          tabList={tabList}
          onTabChange={onTabChange}
        />
      </div>
      <div className="createProjectIndicationContainer__content">
        {isSelectedTooth && indicationTab === 0 && (
          <ProjectIndicationType
            isTypeMore={isTypeMore}
            indicationPartList={indicationPartList}
            indicationIdx={indicationIdx}
            onMoreChange={onMoreChange}
            onIndicationChange={onIndicationChange}
          />
        )}
        {isSelectedTooth && indicationTab === 1 && (
          <ProjectIndicationMaterial
            indicationMaterialList={indicationMaterialList}
            materialIdx={materialIdx}
            onMaterialChange={onMaterialChange}
          />
        )}
        {isSelectedTooth && indicationTab === 2 && (
          <ProjectIndicationShade
            indicationShadeList={indicationShadeList}
            materialShade={materialShade}
            onShadeChange={onShadeChange}
          />
        )}
        {!isSelectedTooth && <ProjectIndicationNone />}
      </div>
    </StyledCreateProjectIndication>
  );
}

const StyledCreateProjectIndication = styled.div<{ $isSelectedTooth: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${({ $isSelectedTooth }) => ($isSelectedTooth ? 'transparent' : '#f9f9fb')};
  .createProjectIndicationContainer__tab_container {
  }
  .createProjectIndicationContainer__content {
    height: 100%;
    overflow: auto;
  }
`;

export default CreateProjectIndicationContainer;
